import React from 'react'

import { addIntersectionObserver, removeIntersectionObserver } from '@cinch/oxd-utils/browser-support/src'

const IntersectionObserverWrapper: React.FC<{
  onIntersection: (isIntersecting: boolean, initialLoad: boolean) => any
  children?: React.ReactNode | React.ReactNodeArray
  className?: string
}> = ({ onIntersection, children, className }) => {
  const [elemRef, setElemRef] = React.useState<Element | null>(null)

  React.useEffect(() => {
    if (!elemRef) {
      return
    }
    addIntersectionObserver(onIntersection, elemRef)

    return () => {
      if (elemRef) {
        removeIntersectionObserver(elemRef)
      }
    }
  }, [elemRef, children])

  const handleRef = (ref: any) => {
    setElemRef(ref)
  }

  return (
    <div className={className} ref={handleRef}>
      {children}
    </div>
  )
}

export default IntersectionObserverWrapper
